const { countries, zones } = require("moment-timezone/data/meta/latest.json");
const getCountry = () => {
    const cityTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const country = countries[zones[cityTimeZone].countries[0]].name;
    return country
};

export default getCountry;
